import React from 'react';
import { Box, Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const pages = [
  { label: 'VAT Invoice', path: '/invoice' },
  { label: 'P VAT Invoice', path: '/p-vat-invoice' },
  { label: 'Credit Note', path: '/credit' },
  { label: 'Debit Note', path: '/debit' },
  { label: 'Quote', path: '/quote' },
  { label: 'VAT Trial', path: '/vat-trial' },
  { label: 'VAT List', path: '/list' }
];

export default function DocumentNavigation() {
  const { pathname } = useLocation();

  return (
    <Box
      component="nav"
      aria-label="Document navigation"
      sx={{
        direction: 'ltr',
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(2, minmax(0, 1fr))',
          sm: 'repeat(3, minmax(0, 1fr))',
          lg: 'repeat(7, minmax(0, 1fr))'
        },
        gap: 1,
        width: '100%',
        maxWidth: 1220,
        mx: 'auto',
        mb: 1.5,
        p: 1,
        border: '1px solid rgba(11,31,58,.08)',
        borderRadius: 3,
        backgroundColor: 'rgba(255,255,255,.94)',
        boxShadow: '0 8px 24px rgba(11,31,58,.07)'
      }}
    >
      {pages.map(({ label, path, disabled }) => (
        <Button
          key={label}
          {...(!disabled && {
            component: Link,
            to: path,
            'aria-current': pathname === path ? 'page' : undefined
          })}
          disabled={disabled}
          sx={{
            minWidth: 0,
            width: '100%',
            direction: 'ltr',
            minHeight: 42,
            borderRadius: 3,
            px: 2,
            fontWeight: 800,
            textTransform: 'none',
            boxShadow: 'none',
            transition: 'transform .18s ease, box-shadow .18s ease, background .18s ease',
            color: '#0B1F3A',
            ...(pathname === path && !disabled && {
              color: '#FFFFFF',
              backgroundColor: '#0B1F3A',
              '&:hover': {
                backgroundColor: '#173D68'
              }
            }),
            '&:hover': {
              color: '#FFFFFF',
              backgroundColor: '#173D68',
              transform: 'translateY(-1px)',
              boxShadow: '0 10px 22px rgba(11,31,58,.14)'
            },
            '&.Mui-disabled': {
              color: '#667085',
              opacity: 0.65,
              backgroundColor: 'transparent'
            }
          }}
        >
          {label}
        </Button>
      ))}
    </Box>
  );
}
